import { render, staticRenderFns } from "./VulnsListPage.vue?vue&type=template&id=9b6a0c78"
import script from "./VulnsListPage.vue?vue&type=script&lang=js"
export * from "./VulnsListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports